import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { AlertIcon } from 'src/icons';
import { SuperAdminModal } from '../../../baseComponents';
import { deleteOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';

const DeleteOrganization = ({
  isOpen,
  setIsOpen,
  isfilterOn,
  selectedOrganization,
}) => {
  const dispatch = useDispatch();
  const { getOrganizationById } = useSelector(
    (state) => state?.organizationState
  );

  const initialValues = {
    condition_id: '',
  };

  const sections = [
    {
      heading: (
        <div className="flex items-center mb-4">
          <AlertIcon className="mr-2" />
          {getOrganizationById?.allow_delete
            ? 'Remove organization'
            : `Cannot delete organization ${getOrganizationById?.organization_details?.org_name}`}
        </div>
      ),
      className: 'grid grid-cols-1 gap-4',
      fields: [
        {
          type: 'label',
          title: (
            <>
              <span>
                {getOrganizationById?.allow_delete ? (
                  'Are you sure you want to remove this organization'
                ) : (
                  <span>
                    <span>You cannot delete organization</span>
                    <span className="font-bold ml-1">
                      {getOrganizationById?.org_name}
                    </span>
                    <span className="ml-1">
                      since it is linked to other data
                    </span>
                  </span>
                )}{' '}
              </span>
              <span className="font-bold">
                {' '}
                {getOrganizationById?.allow_delete
                  ? `${getOrganizationById?.org_name} ?`
                  : ''}{' '}
              </span>
            </>
          ),
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      closable={false}
      initialValues={initialValues}
      submitButtonText={getOrganizationById?.allow_delete ? 'Submit' : null}
      cancelButtonText={
        getOrganizationById?.allow_delete ? 'Cancel' : 'Go back'
      }
      className={'delete-modal'}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {
        dispatch(
          deleteOrganizationAction(
            getOrganizationById?.org_id,
            setIsOpen,
            isfilterOn,
            selectedOrganization
          )
        );
      }}
    />
  );
};

export default DeleteOrganization;
